import React from 'react'
import type { PlaceSuggestionStatus } from '../api/map'

interface AdminPlaceSuggestionStatusBadgeProps {
  status: PlaceSuggestionStatus
}

/** 상태별 표시 문구와 색 */
const STATUS_STYLE: Record<
  PlaceSuggestionStatus,
  { label: string; className: string }
> = {
  // 미처리는 할 일이므로 가장 눈에 띄게 둔다.
  pending: {
    label: '미처리',
    className: 'bg-4B3621-80% text-white',
  },
  registered: {
    label: '등록 완료',
    className: 'bg-4B3621-80%-5% text-textColorText2 border border-brandPrimary-20%',
  },
  rejected: {
    label: '반려',
    className: 'bg-transparent text-textColorText3 border border-brandPrimary-20%',
  },
}

const AdminPlaceSuggestionStatusBadge: React.FC<
  AdminPlaceSuggestionStatusBadgeProps
> = ({ status }) => {
  const style = STATUS_STYLE[status] ?? STATUS_STYLE.pending

  return (
    <span
      className={`inline-block py-4px px-10px rounded-20px text-style-labelS whitespace-nowrap ${style.className}`}
    >
      {style.label}
    </span>
  )
}

export default AdminPlaceSuggestionStatusBadge
